import { render, staticRenderFns } from "./PortalLayout.vue?vue&type=template&id=35dadcd0"
import script from "./PortalLayout.vue?vue&type=script&lang=js"
export * from "./PortalLayout.vue?vue&type=script&lang=js"
import style0 from "./PortalLayout.vue?vue&type=style&index=0&id=35dadcd0&prod&lang=css"
import style1 from "@/assets/styles/portal/portal-layout.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports